
// Single source of truth for VeraInsight's product portfolio — Homepage,
// ProductsPage, Header, and Footer all read from this file instead of
// each keeping their own copy. Previously Homepage.jsx and ProductsPage.jsx
// each maintained a separate, hand-duplicated products array — real risk
// of the two drifting out of sync (which had already happened: NephroTrax
// was marked "Live" in one build's assumptions but "Coming Soon" with an
// inaccurate, aspirational feature list in both page copies).
//
// Icons are passed in from each consuming page (kept out of this file) so
// this stays plain data, importable anywhere including non-component code.

export const PRODUCTS = [
  {
    key: "amyloidconnect",
    name: "AmyloidConnect",
    tagline: "Amyloidosis Clinical Trials Platform",
    description:
      "The most comprehensive platform for the amyloidosis community. Search 150+ clinical trials, access educational resources, use medical calculators, and connect with specialists. Serving AL, ATTR, and cardiac amyloidosis patients.",
    color: "#667eea",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    status: "Live",
    statusColor: "success",
    features: [
      "150+ Clinical Trials",
      "AI-Powered Trial Matching",
      "Integrated Travel Booking for Trial Visits",
      "Patient Education Center",
      "Medical Calculators",
      "Provider & Specialist Directory",
      "100% Free for Patients",
      "HIPAA Compliant",
    ],
    path: "/products/amyloidconnect",
    url: "www.amyloidconnect.com",
    externalUrl: "https://www.amyloidconnect.com",
    cta: "Visit AmyloidConnect",
  },
  {
    key: "nephrotrax",
    name: "NephroTrax",
    tagline: "Chronic Kidney Disease Care Platform",
    description:
      "A connected platform for CKD patients and the providers who care for them — daily health check-ins on one side, a real-time provider dashboard with automated clinical alerts on the other, so nothing concerning goes unnoticed between visits.",
    color: "#00897b",
    gradient: "linear-gradient(135deg, #00897b 0%, #00695c 100%)",
    status: "Live",
    statusColor: "success",
    features: [
      "Provider Dashboard & Attention Queue",
      "Automated Clinical Alerts",
      "Daily Patient Check-Ins",
      "Epic EHR Lab Sync",
      "Integrated Travel Booking for Appointments",
      "Multi-Practice Provider Support",
      "Specialist Directory",
      "Free for Patients",
      "HIPAA Compliant",
    ],
    path: "/products/nephrotrax",
    url: "www.nephrotrax.com",
    externalUrl: "https://www.nephrotrax.com",
    cta: "Visit NephroTrax",
  },
  {
    key: "compass",
    name: "Compass",
    tagline: "Pediatric Cancer Resource Navigator",
    description:
      "Built for families navigating a pediatric cancer diagnosis. Compass searches clinical trials and community resources side by side — ClinicalTrials.gov, NCI, and local 211 services — with an AI Copilot on hand to explain what any result actually means for your child.",
    color: "#B45309",
    gradient: "linear-gradient(135deg, #B45309 0%, #92400E 100%)",
    status: "Live",
    statusColor: "success",
    features: [
      "Multi-Source Trial Search",
      "ClinicalTrials.gov + NCI Integration",
      "211 Community Resource Search",
      "AI Copilot for Plain-English Guidance",
      "Built for Pediatric Cancer Families",
      "Free to Use",
    ],
    path: "/products/compass",
    url: "verainsight.com/compass",
    externalUrl: "/compass",
    cta: "Open Compass",
  },
  {
    key: "resourceclan",
    name: "ResourceClan",
    tagline: "Social Services Resource Directory",
    description:
      "A general-purpose social-services resource directory, built on the same platform foundation as our disease-specific tools — connecting anyone, not just a specific patient community, with the local support services they need.",
    color: "#5B21B6",
    gradient: "linear-gradient(135deg, #5B21B6 0%, #4C1D95 100%)",
    status: "In Progress",
    statusColor: "warning",
    features: [
      "Local Resource Directory",
      "Community Services Search",
      "Built on Our Proven Platform Foundation",
    ],
    path: "/products/resourceclan",
    url: "Coming Soon",
    externalUrl: null,
    cta: "Coming Soon",
  },
];

export const LIVE_PRODUCTS = PRODUCTS.filter((p) => p.status === "Live");
export const IN_PROGRESS_PRODUCTS = PRODUCTS.filter((p) => p.status !== "Live");